import {
  PLATFORM_ROOT,
  VB_BASE_URL,
} from '@zapier/product-dev-platform/src/constants';

export const HEADER_NAV_USER_LINKS = [
  {
    label: 'How to Build',
    href: `${PLATFORM_ROOT}/how-to-build`,
  },
  {
    label: 'Partner Program',
    href: `${PLATFORM_ROOT}/partner-program`,
  },
  {
    label: 'Documentation',
    href: 'https://platform.zapier.com/docs',
  },
  {
    label: 'Help',
    href: `${VB_BASE_URL}/contact`,
  },
];

export const CTA_LINKS = [
  {
    label: 'My Integrations',
    href: '/app/developer',
  },
  {
    label: 'Zap Templates',
    href: '/zap-templates/',
  },
];

export const USER_LINKS = [
  {
    label: 'Settings',
    href: '/app/developer/partner-settings',
  },
];
